import type { TFunction } from 'i18next';
import { parseJitPoError } from '@/lib/jit-po-errors';

/**
 * BLU-1268: the sentence for a stock edit the server refused because the
 * (blank, location) pair is Just in time: it has no stock number to change.
 * Null when the error is not that refusal (the caller then tries its others).
 */
export function justInTimeStockRefusal(t: TFunction<'inventory'>, error: unknown): string | null {
  return parseJitPoError(error)?.key === 'BLANK_JUST_IN_TIME' ? t('supply.stockRefused') : null;
}
